const jobReQualStatus = (aJob, doneMessage, pendingMessage) => {
    return aJob.requalNotSubmitted_TWIA ? pendingMessage : doneMessage;
};

const showJobsItemInRenewals = aJob => {
if (!aJob.reQualificationNeeded_TWIA) {
    return true;
}
return aJob.requalNotSubmitted_TWIA;
};
export default {
jobReQualStatus,
showJobsItemInRenewals
};
